@if (vm$ | async; as vm) {
    <bs-reward-tokens-info [tokenContext]="vm.rewardTokenContext"></bs-reward-tokens-info>
    @if (!isEpcotEnabled && notifications$ | async; as notifications) {
        <bs-quick-bet-acca-boost-notification [accaBoostNotification]="notifications"></bs-quick-bet-acca-boost-notification>
    }
    <div
        class="quick-bet half-sheet"
        [ngClass]="{
            'quick-bet--disabled': vm.quickBetState.isDisabled,
            'header-active': quickBetConfig.isHeaderEnabled,
        }">
        @if (quickBetConfig.isHeaderEnabled) {
            <bs-quick-bet-header (click)="toggleQbForm()"></bs-quick-bet-header>
        }

        @if (!isEpcotEnabled) {
            <ng-container *ngTemplateOutlet="notifications"></ng-container>
        }
        @if (quickDepositOpen) {
            <bs-quick-deposit [keepOpen]="vm.quickBetState.actionButtonState.isProcessing" [trackingSource]="quickDepositSource"></bs-quick-deposit>
        }

        <div class="quick-bet__body" [ngClass]="{ 'quick-bet__body--locked': isLocked$ | async, 'quick-bet__body--epcot': isEpcotEnabled }">
            @if (isEpcotEnabled) {
                <div class="quick-bet-notification__main-container">
                    <ng-container *ngTemplateOutlet="notifications"></ng-container>
                </div>
            }

            <bs-quick-bet-picks-handler-container
                [oddsDisplayFormat]="oddsDisplayFormat"
                [singleBetId]="vm.quickBetState.pickIds[0]"
                [pickList]="vm.pickList">
            </bs-quick-bet-picks-handler-container>
            @if (quickBetConfig.isPossibleWinningsUnderStakeInputEnabled && vm.isExpanded && vm.rewardTokenContext) {
                <div class="quick-bet__token_summary">
                    <bs-digital-token-summary-container *msShowInEpcot="{ showInEpcot: false }" [tokenContext]="vm.rewardTokenContext">
                    </bs-digital-token-summary-container>
                </div>
            }
            @if (!quickDepositOpen && (numpadInitialized$ | async)) {
                <bs-numpad-host-container [id]="QUICK_BET_NUMPAD"></bs-numpad-host-container>
            }
            @if (!quickDepositOpen && !hasNewCustomerOfferPick && vm.isExpanded) {
                <div class="quick-bet__reward-tokens-selector" [@rewardTokenInOut]="rewardTokensAnimation()">
                    <bs-reward-tokens-selector-container [tokenContext]="vm.rewardTokenContext"></bs-reward-tokens-selector-container>
                </div>
            }

            @if (!isEpcotEnabled && notifications$ | async; as notifications) {
                <bs-quick-bet-acca-boost-ladder [accaBoostNotification]="notifications"></bs-quick-bet-acca-boost-ladder>
            }
            @if (vm.isExpanded) {
                <bs-quick-bet-summary></bs-quick-bet-summary>
            }
        </div>
        @if (vm.isExpanded) {
            <bs-quick-bet-footer [@footerInOut]="footerAnimation()" [rewardTokenContext]="vm.rewardTokenContext"></bs-quick-bet-footer>
        }
        @if (summary$ | async; as summary) {
            <bs-turnover-tax [betslipSummary]="summary.summary"></bs-turnover-tax>
        }
    </div>
}

<ng-template #notifications>
    <bs-quick-bet-pick-notification></bs-quick-bet-pick-notification>
    <bs-quick-bet-bet-builder-notification></bs-quick-bet-bet-builder-notification>
    <bs-quick-bet-place-bet-warning></bs-quick-bet-place-bet-warning>
    <bs-quick-bet-pick-error></bs-quick-bet-pick-error>
</ng-template>
